import type { CpmReportCampaignQuery, CpmReportSubmissionsQuery } from '@/generated/cpm-report';

export type ReportCampaign = NonNullable<CpmReportCampaignQuery['adminCpmCampaign']>;
export type ReportSubmission = CpmReportSubmissionsQuery['adminCpmCampaignSubmissions']['data'][number];
/** One day of approved spend from the campaign stats (backend `daily_spend`). */
export type ReportSpendDay = { date: string; spend_cents: number };
export type ReportSnapshot = {
  campaign: ReportCampaign;
  submissions: ReportSubmission[];
  /** Absent: no budget burndown in the report. Present: must add up to the approved credits. */
  dailySpend?: ReportSpendDay[];
  collectionStartedAt: string;
  collectionFinishedAt: string;
};

export class CampaignReportError extends Error {
  constructor(public readonly code: 'invalid' | 'inconsistent' | 'load' | 'ai_unavailable' | 'ai_busy' | 'ai_failed') {
    super(code);
    this.name = 'CampaignReportError';
  }
}
